/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StockValueResponseDto } from '../../models/stock-value-response-dto';

export interface StockReportsControllerGetCurrentValue$Params {
}

export function stockReportsControllerGetCurrentValue(http: HttpClient, rootUrl: string, params?: StockReportsControllerGetCurrentValue$Params, context?: HttpContext): Observable<StrictHttpResponse<StockValueResponseDto>> {
  const rb = new RequestBuilder(rootUrl, stockReportsControllerGetCurrentValue.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StockValueResponseDto>;
    })
  );
}

stockReportsControllerGetCurrentValue.PATH = '/stock/reports/current-value';
